<template>
	<div>
		<div class="content">
			<!-- 风险数据统计情况 -->
			<div id="riskDataStatistics">
				<div class="title">
					<div class="leftSquare"></div>
					<div class="text">风险数据统计情况</div>
				</div>

				<ul id="riskDataBox">
					<li class="item" v-for="(item,index) in riskDataList" :key="index">
						<div class="num"
							:class="item.risk_level_id == 4?'numColor4':item.risk_level_id == 3?'numColor3':item.risk_level_id == 2?'numColor2':'numColor1'">
							{{item.total}}
						</div>
						<div class="riskName">
							<div class="icon">
								<img style="width: 1.25rem;height: 1.25rem;" src="../../common/img/leftTop/major.png"
									v-if="item.risk_level_id == 4">
								<img style="width: 1.25rem;height: 1.25rem;" src="../../common/img/leftTop/larger.png"
									v-else-if="item.risk_level_id == 3">
								<img style="width: 1.25rem;height: 1.25rem;" src="../../common/img/leftTop/general.png"
									v-else-if="item.risk_level_id == 2">
								<img style="width: 1.25rem;height: 1.25rem;" src="../../common/img/leftTop/low.png"
									v-else>
							</div>
							<div class="text">{{item.risk_level_name}}</div>
						</div>
					</li>
				</ul>
			</div>
			<!-- 风险数据统计情况 -->

			<!-- 隐患状态分析 -->
			<div id="hiddenStateAnalysis">
				<div class="title">
					<div class="leftSquare"></div>
					<div class="text">隐患状态分析</div>
				</div>

				<div id="hiddenStateBox" v-if="isShow">
					<div id="circleDiagram"></div>
				</div>
				<div v-else class="nothing">
					<img src="../../common/img/nothing.png" alt="" style="width: 8.5rem;height: 7.9375rem;">
				</div>
			</div>
			<!-- 隐患状态分析 -->
		</div>
	</div>
</template>
<script>
	import {
		apiurl,
		imgurl
	} from '../../common/js/baseApi.js'
	import axios from 'axios'
	export default {
		components: {},
		data() {
			return {
				riskDataList: [], // 风险数据统计数据
				pId: '', // 用户id
				isShow: true, // 是否显示
				nowClientWidth: 1920 // 默认屏幕宽度
			}
		},
		computed: {},
		watch: {},
		methods: {
			// 风险数据统计数据
			getTotalByRiskLevel() {
				axios.get(apiurl + '/index/totalByRiskLevel', {
						params: {
							pId: this.pId
						}
					})
					.then(data => {
						if (data.data.status !== 1) {
							return
						}
						this.riskDataList = data.data.data
					})
					.catch(err => {

					})
			},

			// 隐患状态分析数据
			getTotalByOrder() {
				axios.get(apiurl + '/index/totalByOrder', {
						params: {
							pId: this.pId
						}
					})
					.then(data => {
						if (data.data.status !== 1) {
							return this.isShow = false
						}
						let res = data.data.data

						if (res.length == 0) {
							this.isShow = false
						}

						var myChart = this.$echarts.init(document.getElementById('circleDiagram'));

						var option = {
							tooltip: {
								trigger: 'item'
							},
							series: [{
								name: '',
								type: 'pie',
								radius: ['30%', '70%'],
								avoidLabelOverlap: true,
								itemStyle: {
									borderRadius: 5,
									borderWidth: 5
								},
								label: {
									formatter: '{b}\n{d}%',
									color: "#fff",
									textBorderColor: "#fff",
									fontSize: this.nowSize(12)
								},
								labelLine: {
									length: this.nowSize(20),
									length2: this.nowSize(20)
								},
								data: res
							}]
						};
						myChart.setOption(option);
					})
					.catch(err => {

					})
			},

			nowSize(val, initWidth = 1920) {
				return val * (this.nowClientWidth / initWidth);
			}
		},
		created() {},
		mounted() {
			this.nowClientWidth = document.documentElement.clientWidth;
			var url = window.location.search
			var theRequest = new Object()
			if (url.indexOf('?') != -1) {
				var str = url.split('?')[1]
				var strs = str.split('&')
				for (var i = 0; i < strs.length; i++) {
					theRequest[strs[i].split('=')[0]] = (strs[i].split('=')[1])
				}
			}
			this.pId = theRequest.pId
			this.getTotalByRiskLevel()
			this.getTotalByOrder()
		},
		beforeCreate() {},
		beforeMount() {},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		activated() {},
	}
</script>
<style lang='scss' scoped>
	@mixin titleStyle {
		.title {
			position: absolute;
			left: 0;
			top: -0.625rem;
			display: flex;
			align-items: center;

			.leftSquare {
				width: 0.25rem;
				height: 1.25rem;
				background-color: #00EAFF;
				margin-right: 0.875rem;
			}

			.text {
				font-size: 1.25rem;
				color: #00EAFF;
			}
		}
	}

	.content {
		width: 33.5rem;
		height: 29rem;
		background: url(../../common/img/leftTop/bg.png) 0 0 no-repeat;
		background-size: 100% 100%;

		/* 风险数据统计 */
		#riskDataStatistics {
			position: relative;
			width: 100%;
			height: 8.25rem;

			@include titleStyle;

			#riskDataBox {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 0.625rem;
				box-sizing: border-box;

				.item {
					width: 8.375rem;
					height: 7.625rem;
					box-sizing: border-box;
					padding: 1.875rem 0;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: space-between;

					.num {
						font-size: 2.5rem;
						font-family: SimHei;
						font-weight: bold;
					}

					.riskName {
						display: flex;
						align-items: center;
						justify-content: center;

						.text {
							margin-left: 0.3125rem;
							font-size: 1rem;
							color: #AFB0B9;
						}
					}

					.numColor1 {
						color: #2A9DFF;
					}

					.numColor2 {
						color: #FED833
					}

					.numColor3 {
						color: #FF6800
					}

					.numColor4 {
						color: #FF1D1D
					}
				}
			}
		}

		/* 风险数据统计 */

		/* 隐患状态分析 */
		#hiddenStateAnalysis {
			position: relative;
			width: 100%;
			height: 20.125rem;
			@include titleStyle;

			#hiddenStateBox {
				display: flex;
				align-items: center;
				justify-content: center;
				box-sizing: border-box;
				margin-top: 0.625rem;
				width: 100%;
				height: 100%;

				#circleDiagram {
					padding-top: 0.625rem;
					width: 100%;
					height: 100%;
					box-sizing: border-box;
				}
			}

			.nothing {
				width: 100%;
				height: 100%;
				margin-top: 0.625rem;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
			}
		}

		/* 隐患状态分析 */
	}
</style>



// WEBPACK FOOTER //
// src/components/leftTop/index.vue